<template>
    <section>
        <div class="row align-items-center mt-5 mb-5 ml-1 justify-content-center">
            <div class="col-7">
                <h5 class="pb-3">Auto Extending EWaybills</h5>
                <form>
                    <div class="form-row">

                        <div class="col-auto">

                            <div class="form-group">
                                <label>Auto Extend On</label>
                                <date-picker v-model="date" :config="optionsDt"></date-picker>
                            </div>

                        </div>

                        <div class="col-auto">
                            <div class="form-group">
                                <div style="display: block;height: 30px;"></div>
                                <button class="btn btn-primary" @click="updateExtended()">
                                    <i class="fa fa-check"></i> Update
                                </button>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <div style="display: block;height: 30px;"></div>
                                <b-btn v-b-tooltip.hover
                                       title="Extend an EWaybill"
                                       variant="secondary"
                                       v-b-modal.newExtend>
                                    <i class="fa fa-tools"></i>
                                    Extend an EWaybill
                                </b-btn>
                            </div>
                        </div>

                    </div>

                </form>
            </div>
        </div>

        <div class="row">
            <div class="col">

                <table class="table table-striped table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th>EWB</th>
                        <th>Old Validity</th>
                        <th>Extended?</th>
                        <th>New Validity</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="f of extensions" :key="f.ewbNo">
                        <td>{{f.ewbNo}}</td>
                        <td>{{f.extendRequested|date}}</td>
                        <td v-if="f.completed">
                        <span>
                            <span class="text-success" v-if="f.extended">
                                <i class="fa fa-check"></i>
                            </span>
                            <span class="text-danger" v-if="!f.extended">
                                <i class="fa fa-times"></i>
                            </span>
                        </span>
                        </td>
                        <td v-if="f.completed">
                        <span v-if="f.extended" class="text-success">
                            {{f.newValidity|date:'dd/MM/yyyy'}}
                        </span>
                            <span v-if="!f.extended" class="text-danger">
                            {{f.errMsg}}
                        </span>
                        </td>
                        <td v-if="!f.completed" colspan="2" class="text-info" aria-colcount="2">
                           In Queue for Extension
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal id="newExtend" ref="newExtend" title="Extend E-Waybill" size="lg" centered lazy hide-footer>

            <div class="form-row">
                <div class="col">
                    <div class="form-group">
                        <label for="">State</label>
                        <select v-model="credId" class="form-control">
                            <option v-for="c of creds" :key="c.id" :value="c.id">{{c.userName}}</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label for="">EWB Number</label>
                        <input type="text" class="form-control" v-model="ewb" minlength="12" maxlength="12"
                               pattern="\d{12}"/>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <div style="display: block;height: 30px;"></div>
                        <button @click="checkValid()" class="btn btn-info">
                            <i class="fa fa-tools"></i>
                            Add to Extend Queue
                        </button>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center text-center" v-if="checking">
                <div class="col-12">
                    <h5>Checking</h5>
                    <loading></loading>
                </div>
            </div>
            <div class="row justify-content-center text-danger text-center" v-if="error">
                <div class="col-3">
                    <h5><i class="fa fa-times"></i> Cannot Add to Extend Queue</h5>
                    {{error}}
                </div>
            </div>

        </b-modal>
    </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import Loading from './shared/Loading'

export default {
  name: 'ExtendPage',
  components: {Loading},
  data () {
    return {
      date: new Date(),
      extensions: [],
      optionsDt: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        keepOpen: false,
        collapse: false,
        toolbarPlacement: 'bottom',
        showTodayButton: false
      },
      ewb: '',
      credId: '',
      creds: [],
      checking: false,
      valid: null,
      error: null
    }
  },
  methods: {
    updateExtended: function () {
      axios.get(`/web-app/extend?on=${moment(this.date).format('YYYY-MM-DD')}`).then(resp => {
        this.extensions = resp.data
      }, err => {
        console.error('error in loading extends', err)
      })
    },
    loadCreds: function () {
      axios.get('/app/cred')
        .then(response => {
          this.creds = response.data
        }, error => {
          console.error('error in loading creds', error)
        })
    },
    checkValid: function () {
      let cred = this.creds.filter(c => c.id === this.credId)[0]
      let req = {
        'requestId': new Date().getTime(),
        'credentials': {
          'userName': cred.userName,
          'password': cred.password,
          'gstNumber': cred.gstNumber
        },
        'ewaybillNos': [this.ewb]
      }
      axios.post('https://api.e-waybill.in/api/e-waybill/bulk-get', req)
        .then(resp => {
          this.checking = true
          this.valid = false
          this.error = null
          let timer = setInterval(() => {
            axios.get(`https://api.e-waybill.in/api/e-waybill/bulk-get-status?request_id=${req.requestId}`)
              .then(respx => {
                if (respx.data.status === 'COMPLETED') {
                  let ewb = respx.data.ewaybills[0]
                  this.checking = false

                  if (ewb.valid === true) {
                    if (ewb.validTill == null) {
                      this.error = 'NO Part B Entered'
                    } else {
                      let vt = moment(ewb.validTill).startOf('day')
                      let validTillDays = vt.diff(moment().startOf('day'), 'days')
                      if (validTillDays === 0) {
                        if (ewb.valid === true) {
                          this.valid = true
                          this.error = null
                          this.extendToday()
                        } else {
                          this.error = ewb.status
                        }
                      } else {
                        this.error = `Not Expiring Today, Expiring Only on ${ewb.validTill}`
                      }
                    }
                  } else {
                    this.error = ewb.status
                  }
                  clearInterval(timer)
                }
              }, err => {
                console.error('error in sending to server', err)
              })
          }, 5000)
        }, err => {
          console.error('error in sending to server', err)
        })
    },
    extendToday: function () {
      if (this.ewb.length !== 12) {
        alert('ewaybill must be 12 digits')
        return
      }
      let regExpMatchArray = this.ewb.match(/\d{12}/)
      console.log(this.ewb, /\d{12}/, regExpMatchArray)
      if (!regExpMatchArray) {
        alert('ewaybill must be 12 numbers')
        return
      }
      axios.put(`/web-app/extend?ewb=${this.ewb}&credId=${this.credId}`)
        .then(_ => {
          alert(`${this.ewb} Will be extended tonight`)
          this.$refs.newExtend.hide()
          this.ewb = ''
          this.credId = null
          this.updateExtended()
        }, err => {
          console.error('error in auto extend', err)
        })
    }
  },
  created: function () {
    this.loadCreds()
    this.updateExtended()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExtendPage.vue